import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordApex() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/apex-asset-46"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>The Apex Asset</h3>
        <p className="story-text">
          <p className="story-text">
           This section explores why Bitcoin can be considered the most superior store of value and medium of exchange in the contemporary world. Human societies are often resistant to radical change, particularly when such change affects money. People tend to rely on systems that are familiar and historically trusted, especially when it comes to saving and preserving wealth.
<br/><br/>
In this section, we examine some of the most widely used stores of value and mediums of exchange throughout history and in the modern era. These include assets such as gold, silver, real estate, stocks, and alternative digital assets. Each of these is analyzed to understand its strengths, limitations, and underlying monetary properties.
<br/><br/>
Bitcoin is then studied in contrast to these assets. The section explains how Bitcoin addresses many of the structural flaws found in earlier forms of money while also examining contemporary digital assets such as altcoins. Particular attention is given to attributes such as decentralization, immutability, scarcity, and resistance to manipulation. The discussion is presented in an analytical manner, allowing the learner to assess differences without being given any financial advice.
<br/><br/>
The objective of this section is not to instruct the learner on what decisions to make, but to equip them with a clear framework for understanding why Bitcoin occupies a unique position among monetary assets today. By the end of this section, the learner should be able to independently evaluate claims about value, money, and monetary superiority using first principles.
         <br/><br/> The learner receives a badge at both the beginning and the
            completion of this section. The term “graduate” is purely figurative
            and is used only to congratulate the learner and gamify the learning
            process.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity. </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordApex;
